import React, { useEffect } from 'react';
import classNames from 'classnames';
import { ROLES } from './constants';

const Tab = ({
  customColor,
  children,
  onUnmount,
  onClick,
  onKeyDown,
  selected,
  index,
  className,
  tabRef,
  disabled,
}) => {
  useEffect(() => () => onUnmount(index), [index, onUnmount]);
  return (
    <li
      className={classNames(className, 'TabbedView-tab', {
        'TabbedView-tab--selected': selected,
        'TabbedView-tab--disabled': disabled,
        'CustomColor--borderColor': customColor,
      })}
      aria-selected={selected ? 'true' : 'false'}
      role="tab"
      tabIndex={selected ? '0' : '-1'}
      ref={tabRef}
      onClick={disabled ? null : onClick}
      onKeyDown={onKeyDown}
      children={children}
    />
  );
};

Tab.role = ROLES.TAB;

export default Tab;
